/**
 * Deletes every Cache Storage entry for the current origin (including Workbox
 * precache and runtime caches).
 */
export async function clearServiceWorkerCaches(): Promise<number> {
  if (!window.caches?.keys) {
    return 0;
  }

  const cacheNames = await window.caches.keys();
  await Promise.all(cacheNames.map((name) => window.caches.delete(name)));
  return cacheNames.length;
}

/**
 * Unregisters every service worker for the current origin.
 */
export async function unregisterServiceWorkers(): Promise<number> {
  if (!navigator.serviceWorker?.getRegistrations) {
    return 0;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations.map((registration) => registration.unregister()),
  );
  return registrations.length;
}

/**
 * Clears cached app data, unregisters service workers, and reloads the page.
 */
export async function resetSavedAppData(): Promise<void> {
  await clearServiceWorkerCaches();
  await unregisterServiceWorkers();
  window.location.reload();
}
